// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"_3xwhgchcRh_calculator","invert":"_3SlarWTHhl_calculator","primary":"_22loA6KjK4_calculator","secondary":"_1NJ80a6-z1_calculator"};